import React from "react";
import "./css/Content.css";

function Content() {
  return (
    <div>
      <div className="Content_Main bg-emerald-400 font-medium text-emerald-900 text-center text-[15px] shadow-md mt-14 w-[85%] mx-auto rounded-lg p-[45px]">
        <p className="gap-10">
          Empowering tomorrow's healers with integrity, compassion, and
          excellence. Together, we innovate, collaborate, and celebrate
          diversity in our pursuit of transformative medical education. At
          Kasthuri Medical Mission, we believe in the power of knowledge,
          empathy, and innovation to shape a healthier future for all.
        </p>
      </div>
    </div>
  );
}

export default Content;
